import React from 'react';
import accesodenegado from '../../assets/images/accesodenegado.png';
import './AccessDeniedPage.css';

const AccessDeniedpage = () => {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				width: '100%',
				height: '90vh',
				maxHeight: '100vh',
				overflowY: 'hidden',
				justifyContent: 'center',
			}}
		>
			<img
				src={accesodenegado}
				alt='acceso denegado'
				width={350}
				height={350}
			/>
			<h2 className='text' style={{ width: '60%', textAlign: 'center' }}>
				No tienes permiso para visitar esta página, contacta con un
				administrador si necesitas utilizar esta sección.
			</h2>
		</div>
	);
};

export default AccessDeniedpage;
